import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import SubscriptionRequests from "./requests/SubscriptionRequests";
import SubscriptionPortalFinance from "./finance/SubscriptionPortalFinance";
import SubscriptionOverview from "./overview/SubscriptionOverview";
import MspSubscriptionAccounts from "./mspAccountsSubscription/MspSubscriptionAccounts";
import MspSubscriptionAccountDetails from "./mspAccountsSubscription/MspSubscriptionAccountDetails";
import MspArchivedAccounts from "./mspAccountsSubscription/MspArchivedAccounts";
import { APP_ROUTES, ROUTE_PATHS } from "../../constants/app.constants";
import Header from "./Header";
import MspReport from "./mspAccountsSubscription/msp-report";
import MspReportPreview from "./mspAccountsSubscription/msp-report-preview";
import EmailTemplates from "./email-templates";
import Distributors from "../distributors";
import DistributorInfoPages from "../distributors/distributor-info-pages";

const SubscriptionPortalRoutes = ({ isLoading, accountId, data }) => {
  return (
    <div id="body-container-id" className="body-container hide-scrollbar">
      <Header isLoading={isLoading} accountId={accountId} data={data} />
      <Routes>
        <Route path={APP_ROUTES.subscriptionPortalPages.mspAccounts} element={<MspSubscriptionAccounts />} />
        <Route path={APP_ROUTES.subscriptionPortalPages.mspStackReport.replace(':accountId', '*')} element={<MspReport />} />
        <Route path={APP_ROUTES.subscriptionPortalPages.mspStackReportPreviewShare.replace(':accountId', '*')} element={<MspReportPreview />} />
        <Route path={APP_ROUTES.subscriptionPortalPages.mspArchivedAccounts} element={<MspArchivedAccounts />} />
        <Route path={APP_ROUTES.subscriptionPortalPages.mspArchivedAccountDetails} element={<MspSubscriptionAccountDetails />} />
        <Route path={`${APP_ROUTES.subscriptionPortalPages.mspAccounts}/${APP_ROUTES.subscriptionPortalPages.distributors}`} element={<Distributors />} />
        <Route path={`${APP_ROUTES.subscriptionPortalPages.mspAccountDetails}/*`} element={<MspSubscriptionAccountDetails data={data} isLoading={isLoading} />} />
        <Route path={`${APP_ROUTES.subscriptionPortalPages.accountDetail}/:accountId`} element={<MspSubscriptionAccountDetails />} />
        <Route path={APP_ROUTES.subscriptionPortalPages.finance} element={<SubscriptionPortalFinance />} />
        <Route path={APP_ROUTES.subscriptionPortalPages.overview} element={<SubscriptionOverview />} />
        <Route path={APP_ROUTES.subscriptionPortalPages.requests} element={<SubscriptionRequests />} />
        <Route path={APP_ROUTES.subscriptionPortalPages.emailTemplates} element={<EmailTemplates />} />
        <Route path={APP_ROUTES.subscriptionPortalPages.distributors} element={<Distributors />} />
        <Route path={`${APP_ROUTES.subscriptionPortalPages.distributorDetails}/*`} element={<DistributorInfoPages />} />
        <Route path="" element={<Navigate to={ROUTE_PATHS.subscriptionPortalPages.overview} replace />} />
        <Route path="*" element={<Navigate to={ROUTE_PATHS.subscriptionPortalPages.overview} replace />} />
      </Routes>
    </div>
  )
}

export default SubscriptionPortalRoutes;
